import { FC, useState } from "react";
import { Button, Form, Input, Modal, ModalProps, Row, Space } from "antd";
import { Organization } from "../../types/OrganizationTypes";
import { handleError } from "../../common/ErrorHandling";

interface OrganizationModalProps extends Omit<ModalProps, "onOk"> {
    onOk?: (data: Organization) => Promise<boolean>;
}

export const OrganizationModal: FC<OrganizationModalProps> = ({ onOk, ...restProps }) => {
    const [form] = Form.useForm<Organization>();
    const [loading, setLoading] = useState(false);

    const handleSumbit = async (values: Organization) => {
        setLoading(true);
        try {
            if (await onOk?.(values)) {
                form.resetFields();
            }
        } catch (error) {
            handleError(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal {...restProps} footer={null}>
            <Form form={form} onFinish={handleSumbit} disabled={loading}>
                <Form.Item
                    label="Name"
                    name={["name"]}
                    rules={[{ required: true, message: "Please enter organization name" }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item>
                    <Row justify="end">
                        <Space size={16}>
                            <Button onClick={restProps.onCancel}>Cancel</Button>
                            <Button type="primary" htmlType="submit" loading={loading}>
                                Submit
                            </Button>
                        </Space>
                    </Row>
                </Form.Item>
            </Form>
        </Modal>
    );
};
